import { Component, Input } from '@angular/core';
import {
  ReactiveFormsModule,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { forwardRef } from '@angular/core';

@Component({
  selector: 'app-input-custom',
  imports: [MatInputModule, ReactiveFormsModule],
  templateUrl: './input-custom.html',
  styleUrl: './input-custom.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputCustom),
      multi: true,
    },
  ],
})
export class InputCustom implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() icon?: string;
  @Input() inputClass?: string = '';
  @Input() type?: string = '';
  @Input() hasError?: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() maxLength?: number;

  value: string = '';

  private onChange = (value: string) => {};
  private onTouched = () => {};

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // setDisabledState(isDisabled: boolean): void {
  //   this.disabled = isDisabled;
  // }

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
  }

  onBlur(): void {
    this.onTouched();
  }
}
